import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { FloatingArrow as p } from "../../node_modules/.pnpm/@floating-ui_react@0.27.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { clsx as a } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import t from "./roche-tooltip-content.module.scss.js";
const N = ({
  children: e,
  floatingStyles: r,
  arrowRef: s,
  open: l,
  context: n,
  refs: i,
  ...c
}) => /* @__PURE__ */ m(
  "div",
  {
    ref: i.setFloating,
    style: r,
    role: "status",
    className: a(t["tooltip-content"], l && t["tooltip-content--open"]),
    ...c,
    children: [
      /* @__PURE__ */ o("div", { className: t["tooltip-content__text"], children: e }),
      /* @__PURE__ */ o(p, { className: t["tooltip-content__arrow"], ref: s, context: n })
    ]
  }
);
export {
  N as RocheUITooltipContent
};
